import {ChangeDetectionStrategy, Component, Input, OnChanges} from '@angular/core';
import {NgIf} from '@angular/common';
import {Q9TransformPipe, getFullName, getInitials} from '@q9elements/ui-kit/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-diagram-user-details',
  templateUrl: './diagram-user-details.component.html',
  styleUrls: ['./diagram-user-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, Q9TransformPipe, TranslateModule]
})
export class DiagramUserDetailsComponent implements OnChanges {
  @Input() user: any;
  @Input() userRole: string;
  initials: string;
  fullName: string;
  avatarUrl: string;

  readonly getFullName = getFullName;

  formatUser(user) {
    if (user) {
      if (user.firstName || user.lastName) {
        this.initials = getInitials(user);
        this.fullName = getFullName(user);
      } else {
        this.initials = this.fullName = '?';
      }

      this.avatarUrl = user.avatar_md;
    }
  }

  ngOnChanges(changes) {
    if (changes && changes.user && changes.user.currentValue) {
      this.formatUser(changes.user.currentValue);
    }
  }
}
